<div>
    <form [formGroup]="validationForm">
        <div class="field" *ngIf="customField.custom_field_type_id === customFields.Link">
            <label class="font-medium text-900">{{ customField.label }}</label>
            <span class="asterisk" *ngIf="customField.usage[0].is_required === true">*</span>
            <div>
                <input pInputText formControlName="customFieldLink" id="{{ customField.custom_field_id }}"
                    placeholder="{{ customField.placeholder }}" (change)="changeEvent($event)"
                    (blur)="onValidationStatusChange()" maxlength="100"
                    [ngClass]="{'is-invalid': validationForm.get('customFieldLink')?.invalid && (validationForm.get('customFieldLink')?.dirty || validationForm.get('customFieldLink')?.touched || submit)}">
                <span *ngIf="customField?.instructions">
                    <small>{{ customField.instructions }}</small>
                </span>
            </div>

            <span
                *ngIf="validationForm.get('customFieldLink')?.invalid && (validationForm.get('customFieldLink')?.dirty || validationForm.get('customFieldLink')?.touched || submit)">
                <small class="alert-danger" *ngIf="validationForm.get('customFieldLink')?.errors?.['required']">{{translation_service.getText('message_25')}}</small>
                <small class="alert-danger" *ngIf="validationForm.get('customFieldLink')?.errors?.['invalidWebsiteLink']">{{translation_service.getText('message_428')}}</small>
            </span>
        </div>
    </form>
</div>